import type { MembershipManagementProps } from './membership-management.component';

/**
 * Maps HTML attribute names (kebab-case) to Component prop names (camelCase)
 */
export const MEMBERSHIP_MANAGEMENT_ATTRIBUTE_MAP: Record<string, keyof MembershipManagementProps> =
  {
    'membership-id': 'membershipId',
    'show-block': 'showBlock',
    'tier-ids': 'tierIds',
    title: 'title',
    'title-size': 'titleSize',
    description: 'description',
    'show-login': 'showLogin',
    'show-program-name': 'showProgramName',
    'show-tier-image': 'showTierImage',
    'show-tier-name': 'showTierName',
    'show-tier-description': 'showTierDescription',
    'show-price': 'showPrice',
    'show-quick-add': 'showQuickAdd',
    'max-width': 'maxWidth',
    'show-banner': 'showBanner',
    'show-banner-image': 'showBannerImage',
    columns: 'columns',
    'column-alignment': 'columnAlignment',
    'section-background': 'sectionBackground',
    'column-background': 'columnBackground',
    'section-text-color': 'sectionTextColor',
    'column-text-color': 'columnTextColor',
    'button-color': 'buttonColor',
    'button-text-color': 'buttonTextColor',
    'column-border-color': 'columnBorderColor',
    'column-border-width': 'columnBorderWidth',
    'column-border-radius': 'columnBorderRadius',
    'button-border-radius': 'buttonBorderRadius',
    'vertical-padding': 'verticalPadding',
  };

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'showLogin',
  'showProgramName',
  'showTierImage',
  'showTierName',
  'showTierDescription',
  'showPrice',
  'showQuickAdd',
  'showBanner',
  'showBannerImage',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to Component props
 */
export function extractMembershipManagementAttributes(
  element: HTMLElement
): Partial<MembershipManagementProps> {
  const props: Partial<MembershipManagementProps> = {};
  for (const [attrName, propName] of Object.entries(MEMBERSHIP_MANAGEMENT_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }
  return props;
}
